module.exports = __webpack_public_path__ + "images/SolarWinds-4c4792.png";